/* jshint esversion: 8 */

const tableFieldsConfig = [
  {
    sid: 'id', // 数据库字段名称
    id: 'id',
    label: 'id',

    // 显示相关src/pages/ComfortableHousingMgmt/ComfortableHousingTable/data.js
    display: false, // true，页面打开时可见
    canSort: false, // 此列可排序
    canFilter: false, // 此列可以控制被隐藏或显示

    // 搜索相关
    canSearch: false, // 可以被搜索
    searchType: 'EQUAL', // 搜索类型，为 LIKE 或者 EQUAL

    // 新增数据
    tobeCreatedField: false, // 字段新增
    notEmptyWhenCreating: false, // 创建字段不能为空

    tableCellAlign: 'left', // left(default), center, right
  },
  {
    sid: 'number',
    id: 'number',
    label: '序号',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    notEmptyWhenCreating: true,
    maxLength: '32',
    valueType: 'string',
  },

  {
    sid: 'category',
    id: 'category',
    label: '类别',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '64',
    valueType: 'string',
  },
  {
    sid: 'property_name',
    id: 'propertyName',
    label: '安置房小区名称',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '64',
    valueType: 'string',
  },
  {
    sid: 'villager_name',
    id: 'villagerName',
    label: '拆迁户姓名',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '32',
    valueType: 'string',
  },
  {
    sid: 'building_number',
    id: 'buildingNumber',
    label: '套房幢号',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'room_number',
    id: 'roomNumber',
    label: '套房房号',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'housing_area',
    id: 'housingArea',
    label: '套房面积',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'bicycle_garage_building_no',
    id: 'bicycleGarageBuildingNo',
    label: '自行车库幢号',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'bicycle_garage_no',
    id: 'bicycleGarageNo',
    label: '自行车库号',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'bicycle_garage_area',
    id: 'bicycleGarageArea',
    label: '自行车库面积',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'car_garage_building_no',
    id: 'carGarageBuildingNo',
    label: '汽车库幢号/汽车位',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'car_garage_no',
    id: 'carGarageNo',
    label: '汽车库号',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'car_garage_area',
    id: 'carGarageArea',
    label: '汽车库面积',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'loft_area',
    id: 'loftArea',
    label: '阁楼面积',
    display: false,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '16',
    valueType: 'string',
  },
  {
    sid: 'village_group_name',
    id: 'villageGroupName',
    label: '所在村组',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '64',
    valueType: 'string',
  },
  {
    sid: 'village_name',
    id: 'villageName',
    label: '所在村',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '64',
    valueType: 'string',
  },
  {
    sid: 'project_name',
    id: 'projectName',
    label: '项目',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '64',
    valueType: 'string',
  },
  {
    sid: 'phone',
    id: 'phone',
    label: '联系电话',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '32',
    valueType: 'string',
  },
  {
    sid: 'get_key_time',
    id: 'getKeyTime',
    label: '领钥匙时间',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,
    tableCellAlign: 'right',

    maxLength: '64',
    valueType: 'string',
  },
  {
    sid: 'remark',
    id: 'remark',
    label: '备注',
    display: true,
    canSort: true,
    canFilter: true,
    canSearch: true,
    searchType: 'LIKE',
    tobeCreatedField: true,

    maxLength: '128',
    valueType: 'string',
  },
];



const fields = function (data) { };


exports.tableFieldsConfig = tableFieldsConfig;
exports.fields = fields;
